import React from "react";

function DigitalWalletChevronIcon({ direction = "right", stroke = "#98A2B3" }) {
  const path =
    direction === "left" ? "M10 4L6 8L10 12" : "M6 4L10 8L6 12";

  return (
    <svg className="navigation-direction-icon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d={path}
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default DigitalWalletChevronIcon;
